import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import cartSvg from "@/assets/cart.svg";
import doneCartSvg from "@/assets/done-cart.svg";
import { useServices } from "@/services-context";
import styles from "./add-to-cart.module.scss";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import { useEffect, useState } from "preact/hooks";

export interface AddToCartProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  disabled?: boolean;
  done?: boolean;
  noicon?: boolean;
  className?: string;
  onClick?: () => void;
}

export const AddToCart: React.FC<AddToCartProps> = ({
  type = LayoutStyleTypes.TYPE_LG,
  disabled = false,
  done = false,
  noicon = false,
  className,
  onClick,
}) => {
  const { t } = useTranslation();
  useServices(); // SSR-compatible, just to keep the hook
  const { layoutType } = useLayoutType();
  const [isMobile, setIsMobile] = useState<boolean>(true);

  useEffect(() => {
    setIsMobile(layoutType === LayoutTypes.TYPE_MOBILE);
  }, [layoutType]);

  const getIcon = () => {
    if (done) {
      return <Icon src={doneCartSvg} className={styles.icon} />;
    }
    if (noicon) return null;
    return <Icon src={cartSvg} className={styles.icon} />;
  };

  const getText = () => (done ? t("hr23xk0p7a7783h8.added-to-cart", "Go to cart") : t("mxa4s697394822iw.add-to-cart", "Add to cart"));

  return (
    <div className={isMobile && styles.wrapper}>
      <FixButton variant={"primary"} disabled={disabled} className={classNames(styles.button, styles[type], className)} onClick={onClick}>
        {getIcon()}
        <span className={classNames(styles.label, styles[type])}>{getText()}</span>
      </FixButton>
    </div>
  );
};

export default AddToCart;
